import React, { useCallback, useEffect, useRef } from 'react';
import { FaEnvelope, FaHeadset, FaInstagram, FaTimes, FaWhatsapp, FaYoutube } from 'react-icons/fa';
import { playContactOpenSound } from '../../utils/alertSound';
import { useOverlayBack } from '../../hooks/useSmartBack';
import './ContactCenter.scss';

const CONTACT_OPTIONS = [
  {
    key: 'whatsapp',
    label: 'WhatsApp',
    href: 'https://wa.me/917676572364',
    external: true,
    color: '#25d366',
    icon: <FaWhatsapp />,
  },
  {
    key: 'mail',
    label: 'Email',
    href: 'mailto:miventsite@gmail.com',
    color: '#6366f1',
    icon: <FaEnvelope />,
  },
  {
    key: 'instagram',
    label: 'Instagram',
    href: 'https://www.instagram.com/miventsite/',
    external: true,
    color: '#e4405f',
    icon: <FaInstagram />,
  },
  {
    key: 'youtube',
    label: 'YouTube',
    href: 'https://www.youtube.com/@MIVENTSITE',
    external: true,
    color: '#ff0000',
    icon: <FaYoutube />,
  },
  {
    key: 'feedback',
    label: 'Feedback',
    href: '/support#feedback',
    external: true,
    color: '#f59e0b',
    icon: <FaHeadset />,
  },
];

const ContactCenter = () => {
  const [open, setOpen] = React.useState(false);
  const rootRef = useRef(null);

  // Back press closes the contact menu first (one press = one layer).
  const closeMenu = useCallback(() => setOpen(false), []);
  useOverlayBack(open, closeMenu, 'contact-center');

  useEffect(() => {
    if (!open) return;

    const handleClickOutside = (e) => {
      if (rootRef.current && !rootRef.current.contains(e.target)) setOpen(false);
    };

    document.addEventListener('mousedown', handleClickOutside);
    document.addEventListener('touchstart', handleClickOutside);
    return () => {
      document.removeEventListener('mousedown', handleClickOutside);
      document.removeEventListener('touchstart', handleClickOutside);
    };
  }, [open]);

  return (
    <div className="contact-center" ref={rootRef}>
      {open && (
        <ul className="contact-center__menu">
          {CONTACT_OPTIONS.map((option) => (
            <li key={option.key}>
              <a
                className="contact-center__item"
                href={option.href}
                {...(option.external
                  ? { target: '_blank', rel: 'noopener noreferrer' }
                  : {})}
                onClick={() => setOpen(false)}
              >
                <span className="contact-center__item-icon" style={{ color: option.color }}>
                  {option.icon}
                </span>
                <span className="contact-center__item-label">{option.label}</span>
              </a>
            </li>
          ))}
        </ul>
      )}

      <button
        className={`contact-center__fab ${open ? 'contact-center__fab--active' : ''}`}
        onClick={() => setOpen((prev) => {
          const next = !prev;
          if (next) {
            playContactOpenSound();
          }
          return next;
        })}
        title={open ? 'Close contact center' : 'Contact us'}
        aria-label={open ? 'Close contact center' : 'Open contact center'}
      >
        {open ? (
          <FaTimes />
        ) : (
          <svg
            className="contact-center__fab-icon"
            viewBox="0 0 24 24"
            fill="none"
            stroke="currentColor"
            strokeWidth="2"
            aria-hidden="true"
          >
            <path d="M3 18v-6a9 9 0 0 1 18 0v6" />
            <path d="M21 19a2 2 0 0 1-2 2h-1a2 2 0 0 1-2-2v-3a2 2 0 0 1 2-2h3zM3 19a2 2 0 0 0 2 2h1a2 2 0 0 0 2-2v-3a2 2 0 0 0-2-2H3z" />
          </svg>
        )}
      </button>
    </div>
  );
};

export default ContactCenter;
